export default "__VITE_ASSET__D7CZvG3q__"